import script from "./scroll-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./scroll-view.vue?vue&type=script&setup=true&lang=ts"

import "./scroll-view.vue?vue&type=style&index=0&id=5f467fe3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f467fe3"]])

export default __exports__